import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useFormik } from 'formik';
import { validation } from './validationSchema';

import { useDispatch, useSelector } from 'react-redux';
import { errorHelper, Loader } from '../../../utils/tools'

import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import { Button, Col, Row, Image, Form } from 'react-bootstrap';
import { HiEye, HiEyeOff } from 'react-icons/hi';

import { registerUser } from '../../../store/actions/users';
import PreventSignIn from '../../../hoc/preventSignIn';

import logo from '../../../assets/logo.svg';
import '../../../styles/style.css';
import '../../../styles/tenantSetup.css';

const Register = () => {

    let navigate = useNavigate();
    const { executeRecaptcha } = useGoogleReCaptcha();

    const users = useSelector(state => state.users);
    const notifications = useSelector(state => state.notifications);
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {
            username: '',
            email: '',
            contact: '',
            name: '',
            surname: '',
            password: '',
            confirmPassword: '',
        },
        validationSchema: validation,
        onSubmit: async (values) => {
            if (!executeRecaptcha) return;
            try {
                const recaptchaToken = await executeRecaptcha('register');
                dispatch(registerUser({ ...values, recaptchaToken }));
            } catch (error) {
                console.error("reCAPTCHA error:", error);
            }
        }
    });

    const [usernameTaken, setUsernameTaken] = useState(false);
    const [emailTaken, setEmailTaken] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleEmailBlur = async (e) => {
        formik.handleBlur(e);
        const value = e.target.value;
        if (!value || value.length < 5) { setEmailTaken(false); return; }
        try {
            const res = await axios.get(`/api/auth/check-email?email=${encodeURIComponent(value)}`);
            setEmailTaken(res.data.taken);
        } catch (_) {}
    };

    const handleUsernameBlur = async (e) => {
        formik.handleBlur(e);
        const value = e.target.value;
        if (!value || value.length < 3) { setUsernameTaken(false); return; }
        try {
            const res = await axios.get(`/api/auth/check-username?username=${encodeURIComponent(value)}`);
            setUsernameTaken(res.data.taken);
        } catch (_) {}
    };

    useEffect(() => {
        if (notifications && notifications.global.success) {
            navigate('/dashboard');
        }
    }, [notifications, navigate]);

    return (
        <PreventSignIn users={users}>
            {users.loading ? (
                <div className="centered-loader"><Loader /></div>
            ) : (
                <div className="onboarding-overlay">

                    <div className="onboarding-left">
                        <div className="onboarding-left-content">
                            <div style={{ display: 'flex', gap: '8px', marginBottom: '24px', flexWrap: 'wrap' }}>
                                <span style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: '20px', padding: '4px 14px', fontSize: '0.78rem', color: '#fff', fontWeight: 500, letterSpacing: '0.02em' }}>Evidencia odpadov</span>
                                <span style={{ background: 'rgba(99,179,237,0.15)', border: '1px solid rgba(99,179,237,0.4)', borderRadius: '20px', padding: '4px 14px', fontSize: '0.78rem', color: '#90cdf4', fontWeight: 500, letterSpacing: '0.02em' }}>PPWR</span>
                            </div>
                            <h2>Začnite ešte dnes.<br/>Bezplatne a bez záväzkov.</h2>
                            <p>Registrácia zaberie len pár minút. Ihneď získate prístup k evidencii odpadov aj reportingu obalov podľa nariadenia PPWR.</p>
                            <ul style={{ listStyle: 'none', padding: 0, margin: '20px 0 0 0' }}>
                                {[
                                    'Evidenčné listy a ohlasovanie odpadov',
                                    'Správa skladov a tok odpadov',
                                    'PPWR – evidencia a reporting obalov',
                                    'Exporty a štatistiky pre úrady',
                                ].map((item, i) => (
                                    <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', fontSize: '0.9rem', color: 'rgba(255,255,255,0.88)' }}>
                                        <span style={{ width: '20px', height: '20px', borderRadius: '50%', background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '0.65rem' }}>✓</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="onboarding-right auth-right">
                        <Image src={logo} style={{ height: '32px', width: 'auto', position: 'absolute', top: '32px', right: '48px' }} />

                        <div className="auth-form-inner">
                        <div className="mb-4">
                            <h1>Registrácia</h1>
                            <p style={{ color: '#718094' }}>Registrujte sa do aplikácie evidencie odpadov.</p>
                        </div>

                        <Form onSubmit={formik.handleSubmit}>

                        <div className="onboarding-section">
                            <div className="onboarding-section-title">Prihlasovacie údaje</div>

                            <Form.Group className="mb-3" controlId="formBasicUsername">
                                <Form.Label>Prihlasovacie meno*</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="radius"
                                    placeholder="Zadajte prihlasovacie meno:"
                                    {...formik.getFieldProps('username')}
                                    onChange={(e) => { formik.handleChange(e); setUsernameTaken(false); }}
                                    onBlur={handleUsernameBlur}
                                    isInvalid={usernameTaken || errorHelper(formik, 'username').error}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {usernameTaken ? 'Prihlasovacie meno je už obsadené.' : errorHelper(formik, 'username').helperText}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>E-mail*</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="radius"
                                    placeholder="Zadajte e-mail:"
                                    {...formik.getFieldProps('email')}
                                    onChange={(e) => { formik.handleChange(e); setEmailTaken(false); }}
                                    onBlur={handleEmailBlur}
                                    isInvalid={emailTaken || errorHelper(formik, 'email').error}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {emailTaken ? 'E-mail je už obsadený.' : errorHelper(formik, 'email').helperText}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Heslo*</Form.Label>
                                <div style={{ position: 'relative' }}>
                                    <Form.Control
                                        type={showPassword ? 'text' : 'password'}
                                        className="radius"
                                        placeholder="Zadajte heslo:"
                                        style={{ paddingRight: '2.5rem', backgroundImage: 'none' }}
                                        {...formik.getFieldProps('password')}
                                        isInvalid={errorHelper(formik, 'password').error}
                                    />
                                    <span
                                        onClick={() => setShowPassword(p => !p)}
                                        style={{ position: 'absolute', top: '50%', right: '0.75rem', transform: 'translateY(-50%)', cursor: 'pointer', color: '#6c757d', zIndex: 5 }}
                                    >
                                        {showPassword ? <HiEyeOff size={18} /> : <HiEye size={18} />}
                                    </span>
                                </div>
                                <Form.Control.Feedback type="invalid" style={{ display: errorHelper(formik, 'password').error ? 'block' : 'none' }}>
                                    {errorHelper(formik, 'password').helperText}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-0" controlId="formBasicConfirmPassword">
                                <Form.Label>Zopakujte heslo*</Form.Label>
                                <div style={{ position: 'relative' }}>
                                    <Form.Control
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        className="radius"
                                        placeholder="Zadajte heslo:"
                                        style={{ paddingRight: '2.5rem', backgroundImage: 'none' }}
                                        {...formik.getFieldProps('confirmPassword')}
                                        isInvalid={errorHelper(formik, 'confirmPassword').error}
                                    />
                                    <span
                                        onClick={() => setShowConfirmPassword(p => !p)}
                                        style={{ position: 'absolute', top: '50%', right: '0.75rem', transform: 'translateY(-50%)', cursor: 'pointer', color: '#6c757d', zIndex: 5 }}
                                    >
                                        {showConfirmPassword ? <HiEyeOff size={18} /> : <HiEye size={18} />}
                                    </span>
                                </div>
                                <Form.Control.Feedback type="invalid" style={{ display: errorHelper(formik, 'confirmPassword').error ? 'block' : 'none' }}>
                                    {errorHelper(formik, 'confirmPassword').helperText}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>

                        <div className="onboarding-section">
                            <div className="onboarding-section-title">Osobné údaje</div>

                            <Form.Group className="mb-3" controlId="formBasicContact">
                                <Form.Label>Mobil (+421910123456)*</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="radius"
                                    placeholder="Zadajte mobil:"
                                    {...formik.getFieldProps('contact')}
                                    isInvalid={errorHelper(formik, 'contact').error}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errorHelper(formik, 'contact').helperText}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Row>
                                <Col>
                                    <Form.Group className="mb-0" controlId="formBasicName">
                                        <Form.Label>Meno*</Form.Label>
                                        <Form.Control
                                            type="text"
                                            className="radius"
                                            placeholder="Zadajte meno:"
                                            {...formik.getFieldProps('name')}
                                            isInvalid={errorHelper(formik, 'name').error}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errorHelper(formik, 'name').helperText}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-0" controlId="formBasicSurname">
                                        <Form.Label>Priezvisko*</Form.Label>
                                        <Form.Control
                                            type="text"
                                            className="radius"
                                            placeholder="Zadajte priezvisko:"
                                            {...formik.getFieldProps('surname')}
                                            isInvalid={errorHelper(formik, 'surname').error}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errorHelper(formik, 'surname').helperText}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </div>

                        <div className="onboarding-footer">
                            <p className="auth-register-hint" style={{ margin: 0 }}>
                                Už máte účet?{' '}
                                <Link to="/account/login" className="auth-register-link">
                                    Prihláste sa
                                </Link>
                            </p>
                            <Button className="btn-onboarding-next" type="submit">
                                Registrovať sa
                            </Button>
                        </div>

                        </Form>
                        </div>

                    </div>

                </div>
            )}
        </PreventSignIn>
    );
}

export default Register;
